import React, { useCallback, useEffect, useState } from 'react';
import MessageCarousel from './components/MessagesCarousel';
import { useAppNavigate } from '..';
import { Stashboard, getStashboardData, useSpringBigStore } from '@springbig/shared';
import { useAuthorization } from '~/hooks/auth';
import Loading from '~/shared/Loading';
import { Section } from '~/shared/Theme';

const MessageDetailScreen = () => {

    const { params } = useAppNavigate();
    const { isLoadingAuth } = useAuthorization();
    const [data, setData] = useState<Stashboard | null>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { member, setStashboardTarget, stashboards, setLayoutEnabled } = useSpringBigStore();

    const getMessage = useCallback(async (stashboard_key: string) => {

        const alreadyFetchedStashboard = stashboards?.find((s) => s._key === stashboard_key);

        if (alreadyFetchedStashboard?.redirect_url) {
            window.location.replace(alreadyFetchedStashboard.redirect_url);
            return;
        }

        if (alreadyFetchedStashboard) {
            setData(alreadyFetchedStashboard);
            return;
        }

        setIsLoading(true);

        const result = member && await getStashboardData({
            stashboard_key,
            type: 'sms',
        });

        if (result?.redirect_url) {
            window.location.replace(result.redirect_url);
            return;
        }

        result && setData(result);
        setIsLoading(false);
    }, [member]);

    useEffect(() => {

        if (params && params.stashboard_key) {
            setStashboardTarget(params.stashboard_key);
            getMessage(params.stashboard_key);
        }
    }, [member, params.wallet_id, params.stashboard_key, getMessage]);

    const isSafari = () => {
        const ua = navigator.userAgent;
        const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
        return isSafari;
    };

    useEffect(() => {

        if (data && data?.content_type === 'gated_link' && data?.redirect_link) {
            setLayoutEnabled(false);
            if (isSafari()) {
                requestAnimationFrame(() => {
                    window.location.href = data.redirect_link;
                });
            } else {
                window.location.href = data.redirect_link;
            }
        } else {
            setLayoutEnabled(true);
        }
    }, [data]);

    if (isLoading || isLoadingAuth || !(data && data?.content_type === 'gated_link' && data?.redirect_link)) {
        return <Loading isLoading={true} />;
    }


    return (
        <Section display={'block'}>
            { data && !(data && data?.content_type === 'gated_link' && data?.redirect_link) &&
                <MessageCarousel data={data} />
            }
        </Section>
    );
};

export default MessageDetailScreen;
